import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Table, TableColumnsType } from 'antd';

import Button from '../../Button';
const { Option } = Select;

interface IProps {
  courseInput: any;
  courseList: any;
  onSetCourseInput: Function;
  renderCourseInfo: Function;
  onDeleteCourse: Function;
  isDisabled: boolean;
  setTimesIndex: Function;
  setTimesInputVisible: Function;
}

const SemesterCourse: FC<IProps> = ({
  courseInput,
  courseList,
  onSetCourseInput,
  renderCourseInfo,
  onDeleteCourse,
  isDisabled,
  setTimesIndex,
  setTimesInputVisible,
}) => {
  const { t } = useTranslation();
  const [filteredCourseList, setFilteredCourseList] = useState<any>();

  useEffect(() => {
    if (courseList && courseInput) {
      const selectedCourses: number[] = courseInput.map((item: any) => item.course);
      const list: any = [];
      courseList.forEach((item: any) => {
        if (!selectedCourses.includes(item.value)) {
          list.push(item);
        }
      });
      setFilteredCourseList(list);
      
    }
  }, [courseList, courseInput]);

  const getOptionLabel = (value: number) => {
    const course = courseList.find((item: any) => item.value === value);
    return course ? course.label : '';
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('program.semester.column5'),
      key: 'course',
      render: (value, record, index) => (
        <div className="w-100" style={{ minWidth: '100px' }}>
          <Select
            className="w-100"
            value={courseInput[index].course}
            onChange={value => onSetCourseInput(index, 'course', value)}
            // 임시해제
            // disabled={isDisabled}
          >
            <Option value={courseInput[index].course}>
              {getOptionLabel(courseInput[index].course)}
            </Option>            
            {
              filteredCourseList?.map((item: any) => {
                return (
                  <Option
                    key={item.value}
                    value={item.value}
                  >
                    {item.label}
                  </Option>
                )
              })
            }
          </Select>
        </div>
      ),
    },
    {
      title: t('program.semester.column2'),
      key: 'levelName',
      render: (value, record, index) => {
        return courseInput[index].course
          ? renderCourseInfo(courseInput[index].course, 'levelName')
          : '-';
      },
    },
    {
      title: t('program.semester.column3'),
      key: 'stepName',
      render: (value, record, index) => {
        return courseInput[index].course
          ? renderCourseInfo(courseInput[index].course, 'stepName')
          : '-';
      },
    },
    {
      title: t('program.semester.column17'),
      key: 'weekLectureCount',
      render: (value, record, index) => {
        return courseInput[index].course
          ? `${t('program.course.text1')} ${renderCourseInfo(courseInput[index].course, 'weekLectureCount')} ${t('program.course.text2')}`
          : '-';
      },
    },
    {
      title: t('program.semester.column18'),
      key: 'onlineTuition',
      render: (value, record, index) => {
        return renderCourseInfo(courseInput[index].course, 'onlineTuition') === 0 || renderCourseInfo(courseInput[index].course, 'onlineTuition')
          ? `${renderCourseInfo(courseInput[index].course, 'onlineTuition').toLocaleString()} ${t('program.course.text7')}`
          : '-';
      },
    },
    {
      title: t('program.semester.column19'),
      key: 'alexTuition',
      render: (value, record, index) => {
        return renderCourseInfo(courseInput[index].course, 'alexTuition') === 0 || renderCourseInfo(courseInput[index].course, 'alexTuition')
          ? `${renderCourseInfo(courseInput[index].course, 'alexTuition').toLocaleString()} ${t('program.course.text7')}`
          : '-';
      },
    },
    {
      title: '',
      key: 'buttons',
      render: (value, record, index) => (
        <>
          {
            courseInput[index]
              ? (
                <Button
                  className='btn btn-sm btn-info ml-1'
                  onClick={() => {
                    setTimesIndex(index);
                    setTimesInputVisible(true);
                  }}
                  text={t('program.semester.button5')}
                />
              )
              : null
          }
          {/* {
            isDisabled
              ? null
              : (
                <Button
                  className='btn btn-sm btn-info ml-1'
                  onClick={() => onDeleteCourse(index)}
                  text="삭제"
                />
                )
          } */}
        </>
      )
    }
  ];

  return (
    <div className='tab-table-wrapper'>
      <Table
        columns={columns}
        dataSource={courseInput}
        pagination={{ pageSize: 99999 }}
        rowKey="index"
      />
    </div>
  );
}

export default SemesterCourse;
